export interface ApiError {
  errorCode?: string;
  errorMessage: string;
}

export const isApiError = (v: object): v is ApiError => {
  return "errorMessage" in v;
};
